module.exports = __webpack_public_path__ + "static/media/puzzleClue5.f42bf21d.png";